import { homeFeatures } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            平台特色
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择 JMTT？
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            我们以用户为中心，打造安全、高效、智能的数字化服务平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {homeFeatures.map((feature, idx) => (
            <div
              key={feature.id}
              className="group p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200/70 transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}